<a
    (click)="contactSupport()"
    *ngIf="showSupport"
>Contact Support</a>
<span>Copyright 2025 Ⓒ {{ copyright }}</span>